// Hata mesajlarını formatlamak için utility fonksiyon
export const formatErrorMessage = (error) => {
  if (!error) return 'An error occurred.';
  
  // API error response format
  if (error.data?.errorMessage) {
    return error.data.errorMessage;
  }
  
  // Standard error message
  if (error.message) {
    return error.message;
  }
  
  // HTTP status based messages
  if (error.status) {
    switch (error.status) {
      case 400: return 'Invalid request.';
      case 401: return 'Authentication required.';
      case 403: return 'Access denied.';
      case 404: return 'Resource not found.';
      case 500: return 'Server error.';
      default: return `Error: ${error.status}`;
    }
  }
  
  return 'An unexpected error occurred.';
};

// Error prototype extension
if (!Error.prototype.getFormattedMessage) {
  Error.prototype.getFormattedMessage = function() {
    return formatErrorMessage(this);
  };
}
